import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AnalyticsConsentService } from '../../../shared/services/analytics-consent/analytics-consent.service';
import { ClarityService } from '../../../shared/services/clarity/clarity.service';

/**
 * Guard that checks if analytics consent decision has been made.
 * - If consent is pending (no decision made) -> redirect to /analytics-consent
 * - If consent has been recorded and allowed -> initialise Clarity, then allow navigation
 * - If consent has been recorded but denied -> allow navigation without Clarity
 */
export const analyticsConsentGuard: CanActivateFn = () => {
  const analyticsConsentService = inject(AnalyticsConsentService);
  const clarityService = inject(ClarityService);
  const router = inject(Router);

  if (!analyticsConsentService.hasConsented()) {
    return router.createUrlTree(['/analytics-consent']);
  }

  if (analyticsConsentService.isAllowed()) {
    clarityService.initialise();
  }

  return true;
};
